// extracted by mini-css-extract-plugin
export default {"detailPage":"detailPage_fUvqFIz","detailPage__content":"detailPage__content_Kpew0t8"};